import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { useLang } from '../LangContext';
import { useT } from '../i18n';

export default function EventDetailScreen() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = useT(lang);

  const prizes = [
    { key: 'prize1' },
    { key: 'prize2' },
    { key: 'prize3' },
    { key: 'prize4' },
  ];

  return (
    <div style={{
      backgroundColor: '#f8f5ff',
      minHeight: '100dvh',
      paddingTop: 56,
      paddingBottom: 200,
      fontFamily: "'Be Vietnam Pro', sans-serif",
    }}>
      <TopBar showBack title={t('eventSubtitle')} />

      <div style={{ padding: '20px 16px', maxWidth: 480, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>

        {/* ── Hero Banner ─────────────────────────── */}
        <section style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: '#1A1A2E',
          borderRadius: 24,
          padding: 24,
          minHeight: 220,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        }}>
          <div style={{ position: 'relative', zIndex: 10 }}>
            <div style={{
              display: 'inline-block',
              padding: '3px 12px',
              backgroundColor: '#F9CC61',
              borderRadius: 9999,
              marginBottom: 16,
            }}>
              <span style={{
                color: '#2d2d42', fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700, fontSize: 10, letterSpacing: '0.08em',
              }}>{t('limitedEvent')}</span>
            </div>
            <h1 style={{
              color: '#ffffff',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800, fontSize: 28, lineHeight: 1.2,
              letterSpacing: '-0.02em', marginBottom: 4,
            }}>
              {t('eventTitle')}<br/>
              <span style={{ color: '#ffffff' }}>{t('eventSubtitle')}</span>
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, fontWeight: 500 }}>
              {t('eventPartner')}
            </p>
          </div>

          <div style={{ position: 'relative', zIndex: 10, marginTop: 24 }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 6,
              color: '#F9CC61', fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em',
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
              </svg>
              {t('eventPeriod')}
            </div>
          </div>

          {/* Decorative orbs */}
          <div style={{ position: 'absolute', bottom: -32, right: -32, display: 'flex', zIndex: 1 }}>
            <div style={{ width: 128, height: 128, borderRadius: '50%', backgroundColor: '#FF5C36', opacity: 0.4, filter: 'blur(32px)' }}/>
            <div style={{ width: 96, height: 96, borderRadius: '50%', backgroundColor: '#F9CC61', opacity: 0.3, filter: 'blur(24px)', marginLeft: -64, marginTop: 32 }}/>
          </div>
        </section>

        {/* ── Rules ────────────────────────────────── */}
        <section>
          <h2 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 13, color: '#2d2d42',
            letterSpacing: '0.04em', marginBottom: 10, paddingLeft: 4,
          }}>{t('eventRules')}</h2>

          <div style={{
            backgroundColor: '#ffffff',
            borderRadius: 16,
            padding: 16,
            boxShadow: '0px 4px 12px rgba(45,45,66,0.04)',
          }}>
            {[t('rule1'), t('rule2'), t('rule3')].map((rule, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'flex-start', gap: 12,
                marginBottom: i < 2 ? 16 : 0,
              }}>
                <div style={{
                  flexShrink: 0, marginTop: 1,
                  width: 20, height: 20, borderRadius: '50%',
                  backgroundColor: '#74efce',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="#004c3d">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                </div>
                <span style={{ fontSize: 13, fontWeight: 500, lineHeight: 1.6, color: '#2d2d42' }}>
                  {rule}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* ── Prizes ───────────────────────────────── */}
        <section>
          <h2 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 13, color: '#2d2d42',
            letterSpacing: '0.04em', marginBottom: 10, paddingLeft: 4,
          }}>{t('prizes')}</h2>

          <div style={{ backgroundColor: '#ffffff', borderRadius: 16, overflow: 'hidden', boxShadow: '0px 4px 12px rgba(45,45,66,0.04)' }}>
            {prizes.map(({ key }, i) => (
              <div key={i} style={{
                padding: '14px 16px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                borderBottom: i < prizes.length - 1 ? '1px solid #f2efff' : 'none',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#f9cc61">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  <span style={{ fontSize: 13, fontWeight: 500, color: '#2d2d42' }}>
                    {t(key)}
                  </span>
                </div>
                <div style={{
                  width: 36, height: 36, borderRadius: 10,
                  backgroundColor: '#f2efff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="#b02600">
                    <path d="M20 6h-2.18c.07-.44.18-.88.18-1.36C18 2.07 15.93 0 13.36 0c-1.31 0-2.4.56-3.27 1.44L9 2.9 7.91 1.44C7.04.56 5.95 0 4.64 0 2.07 0 0 2.07 0 4.64c0 .48.11.92.18 1.36H0c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM11 19H4V8h7v11zm1-13.45C11.56 4.71 10.8 4 9.91 4H4.64c-.42 0-.64.21-.64.64 0 .42.21.64.64.64H9l3-.64V5.55zM9 8H4V6h5V8zm6 11h-5V8h5v11zm4 0h-3V8h3v11z"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Notes ────────────────────────────────── */}
        <section style={{
          backgroundColor: '#FFF8E6',
          borderRadius: 16,
          padding: 20,
          borderLeft: '4px solid #F9CC61',
        }}>
          <h3 style={{
            color: '#745700',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700, fontSize: 13, marginBottom: 12,
          }}>{t('notes')}</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: 16, display: 'flex', flexDirection: 'column', gap: 6 }}>
            {[t('note1'), t('note2'), t('note3')].map((note, i) => (
              <li key={i} style={{ color: '#745700', fontSize: 11, fontWeight: 500, lineHeight: 1.6, opacity: 0.9 }}>
                {note}
              </li>
            ))}
          </ul>
        </section>

      </div>

      {/* ── Sticky Footer ──────────────────────────── */}
      <footer style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        maxWidth: 390, margin: '0 auto',
        backgroundColor: 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        padding: '16px 24px 32px',
        boxShadow: '0px -12px 32px rgba(45,45,66,0.06)',
        borderRadius: '32px 32px 0 0',
        zIndex: 40,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 14 }}>
          <div>
            <div style={{
              fontSize: 9, color: 'rgba(45,45,66,0.6)',
              fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 2,
            }}>{t('statusLabel')}</div>
            <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800, fontSize: 13, color: '#9a2000',
            }}>{t('myQualAvailable')}</div>
          </div>
          <div style={{ fontSize: 10, color: '#5a5971', fontWeight: 500, textAlign: 'right' }}>
            {t('currentPointsLabel')}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button
            onClick={() => navigate('/confirm?mode=token')}
            style={{
              height: 52, width: '100%',
              backgroundColor: '#FF5C36', color: '#ffffff',
              border: 'none', borderRadius: 16,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              boxShadow: '0 4px 20px rgba(255,92,54,0.2)',
              transition: 'transform 0.15s',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9.19 6.35c-2.04 2.29-3.44 5.58-3.57 5.65-.08.04 1.08.54 2.59 1.11l-.18.44c-.39 1.03-.39 2.16 0 3.19l.55 1.46 1.57-1.17c.87-.65 1.82-1.15 2.82-1.49L21 19l-2-14-9.81 1.35z"/>
            </svg>
            {t('useQualCta')}
          </button>
          <button
            onClick={() => navigate('/confirm?mode=points')}
            style={{
              height: 52, width: '100%',
              backgroundColor: 'transparent',
              border: '2px solid #FF5C36', color: '#FF5C36',
              borderRadius: 16,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              transition: 'transform 0.15s',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-4h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"/>
            </svg>
            {t('redeemWithPtsCta')}
          </button>
        </div>
      </footer>
    </div>
  );
}
